import { render, staticRenderFns } from "./ClickHereToLoginBtn.vue?vue&type=template&id=78c58972"
import script from "./ClickHereToLoginBtn.vue?vue&type=script&setup=true&lang=js"
export * from "./ClickHereToLoginBtn.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports